import { stripUnit } from "./_stripUnit";

export class SmoothScroll {
  constructor() {
    document.querySelectorAll(`a[href^="#"]`).forEach((link) => {
      link.addEventListener("click", (event) => {
        const { currentTarget } = event;
        event.preventDefault();
        const targetId = currentTarget.hash;
        const target = document.querySelector(targetId);
        // 画面上部から要素までの距離
        const rectTop = target.getBoundingClientRect().top;
        // 現在のスクロール量
        const { pageYOffset } = window;

        const scrollMarginTop = stripUnit(
          window.getComputedStyle(target).getPropertyValue("scroll-margin-top")
        );
        const top = rectTop + pageYOffset - scrollMarginTop;
        window.scrollTo({
          top,
          behavior: "smooth",
        });
      });
    });
  }
}
